import ResearcherHome from '@/pages/researcher/ResearcherHome'

const routes = [
  {
    path: '/researcher',
    name: 'ResearcherHome',
    component: ResearcherHome,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_RESEARCHER']
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/researcher.js